import { icon } from '../utils/icons.js';
import { footerElement } from '../components/Footer.js'

function svgNode(iconName, size) {
  return document.createRange().createContextualFragment(icon(iconName, { size }));
}

function el(tag, className) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  return node;
}

export async function renderContactPage(container) {
  const page = el('div');

  // ── Hero ─────────────────────────────────────────────────────────────────
  const hero = el('section', 'contact-hero');
  const heroInner = el('div', 'rm-container');

  const eyebrow = el('p', 'rm-eyebrow');
  eyebrow.textContent = 'Get Started';

  const h1 = el('h1', 'contact-title');
  h1.textContent = "Let's talk.";

  const sub = el('p', 'contact-sub');
  sub.textContent = '30 minutes. No pressure. Find out if we\'re a good fit.';

  const ctaBtn = el('a', 'rm-btn rm-btn-primary contact-cta');
  ctaBtn.href = 'https://cal.com/cadenburleson';
  ctaBtn.target = '_blank';
  ctaBtn.rel = 'noopener noreferrer';
  const ctaBtnText = el('span');
  ctaBtnText.textContent = 'Book a Free Call';
  const ctaIcon = el('span', 'btn-icon');
  ctaIcon.appendChild(svgNode('arrow-up-right', 16));
  ctaBtn.append(ctaBtnText, ctaIcon);

  const note = el('p', 'contact-note');
  note.textContent = 'Pick a time that works — usually available same week.';

  heroInner.append(eyebrow, h1, sub, ctaBtn, note);
  hero.appendChild(heroInner);

  // ── What we cover ────────────────────────────────────────────────────────
  const coversSection = el('section', 'rm-bento rm-bento--secondary');
  const coversInner = el('div', 'rm-container');

  const coversHeader = el('div', 'rm-bento-header');
  const coversEyebrow = el('p', 'rm-eyebrow');
  coversEyebrow.textContent = 'The Call';
  const coversH2 = el('h2', 'rm-section-title');
  coversH2.textContent = "What we'll cover";
  coversHeader.append(coversEyebrow, coversH2);

  const coversGrid = el('div', 'bento-grid');

  const coverItems = [
    { iconName: 'target',       title: 'Your goals',        body: "What you're building, who it's for, and what success looks like in 90 days." },
    { iconName: 'clock',        title: 'Timeline & scope',  body: 'How quickly you need to move and how the subscription model fits your pace.' },
    { iconName: 'zap',          title: 'First week plan',   body: "We'll map out exactly what gets built first so you can hit the ground running." },
    { iconName: 'dollar-sign',  title: 'Pricing & fit',     body: 'One flat rate, pause or cancel anytime. We\'ll confirm it makes sense for you.' }
  ];

  coverItems.forEach(({ iconName, title, body }) => {
    const card = el('div', 'bento-card bento-3 bento-mini');
    const iconWrap = el('div', 'bento-icon');
    iconWrap.appendChild(svgNode(iconName, 18));
    const h3 = el('h3');
    h3.textContent = title;
    const p = el('p');
    p.textContent = body;
    card.append(iconWrap, h3, p);
    coversGrid.appendChild(card);
  });

  coversInner.append(coversHeader, coversGrid);
  coversSection.appendChild(coversInner);

  // ── Reassurance strip ────────────────────────────────────────────────────
  const stripSection = el('section', 'rm-bento');
  const stripInner = el('div', 'rm-container');
  const stripCard = el('div', 'bento-card bento-12 contact-strip');

  const stripItems = [
    { iconName: 'calendar', text: '30-min video or phone call', href: null },
    { iconName: 'shield',   text: 'Zero commitment required',   href: null },
    { iconName: 'clock',    text: 'Usually available this week', href: null },
    { iconName: 'mail',     text: 'devcaden@gmail.com',         href: 'mailto:devcaden@gmail.com' }
  ];

  stripItems.forEach(({ iconName, text, href }, i) => {
    if (i > 0) {
      stripCard.appendChild(el('span', 'contact-strip-divider'));
    }
    const pill = el('span', 'contact-strip-item');
    const iconSpan = el('span', 'contact-strip-icon');
    iconSpan.appendChild(svgNode(iconName, 15));
    pill.appendChild(iconSpan);

    if (href) {
      const link = el('a', 'contact-strip-link');
      link.href = href;
      link.textContent = text;
      pill.appendChild(link);
    } else {
      const textSpan = el('span');
      textSpan.textContent = text;
      pill.appendChild(textSpan);
    }
    stripCard.appendChild(pill);
  });

  stripInner.appendChild(stripCard);
  stripSection.appendChild(stripInner);

  // ── Bottom CTA ───────────────────────────────────────────────────────────
  const bottomSection = el('section', 'rm-bento');
  const bottomInner = el('div', 'rm-container');
  const bottomCard = el('div', 'bento-card bento-12 bento-card--dark bento-final-cta');

  const bottomEyebrow = el('p', 'rm-eyebrow');
  bottomEyebrow.textContent = 'Ready?';
  const bottomH2 = el('h2');
  bottomH2.textContent = 'One call can change everything.';
  const bottomP = el('p');
  bottomP.textContent = "Book a time, show up, and let's figure out what we can build together.";

  const bottomRow = el('div', 'cta-row');
  const bookBtn = el('a', 'rm-btn rm-btn-primary');
  bookBtn.href = 'https://cal.com/cadenburleson';
  bookBtn.target = '_blank';
  bookBtn.rel = 'noopener noreferrer';
  const bookText = el('span');
  bookText.textContent = 'Book a Call';
  const bookIcon = el('span', 'btn-icon');
  bookIcon.appendChild(svgNode('arrow-up-right', 16));
  bookBtn.append(bookText, bookIcon);
  bottomRow.appendChild(bookBtn);

  bottomCard.append(bottomEyebrow, bottomH2, bottomP, bottomRow);
  bottomInner.appendChild(bottomCard);
  bottomSection.appendChild(bottomInner);

  // ── Footer ───────────────────────────────────────────────────────────────
  const footer = footerElement();

  page.append(hero, coversSection, stripSection, bottomSection, footer);
  container.replaceChildren(page);
}
